import React from 'react';
import SummaryPanel from 'components/common/SummaryPanel';
import { useRetrieveProductReceiptSummary } from 'api/productReceipts/productReceipts';
import { IProductReceiptsSummaryPanel } from './SummaryPanel.properties';
import SummaryTableSchema from './SummaryTableSchema';
import { withStyles } from '@material-ui/core';
import inlineStyles from './SummaryPanel.styles';
import { usePRContextSelector, usePRDispatch } from '../ProductReceipts.context';
import { ProductReceiptsActionTypes } from '../ProductReceipts.actions';

const ProductReceiptsSummaryPanel = (_props: IProductReceiptsSummaryPanel) => {
    const { classes } = _props;
    const contextDispatch = usePRDispatch();

    const fetchSummary = useRetrieveProductReceiptSummary(usePRContextSelector<'ProductReceipt'>((state) => state.ProductReceipt));

    React.useEffect(
        () => {
            if (fetchSummary?.data && fetchSummary?.data?.ProductReceiptSummary !== null) {
                contextDispatch({
                    [ProductReceiptsActionTypes.setSummaryPanelData]: fetchSummary?.data?.ProductReceiptSummary?.inlineObject,
                });
            }
        },
        [fetchSummary?.data]
    );

    return (
        <React.Fragment>
            <SummaryPanel
                loading={fetchSummary.isInitialLoading}
                data={fetchSummary.data?.ProductReceiptSummary?.inlineObject}
                schema={SummaryTableSchema}
                customClassNames={classes.poSummary}
            />
        </React.Fragment>
    );
};

export default withStyles(inlineStyles, { index: 1 })(ProductReceiptsSummaryPanel);
